import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgybbmkhb3: FaireProductEntity = {
  token: "p_mgybbmkhb3",
  type: "product",
  name: "All-Natural Sea Salt - Black Garlic - 2 oz",
  brandToken: "b_4l4trvmb",
  brandName: "Salt Sisters",
  imageUrl:
    "https://cdn.faire.com/fastly/868dcea15b9704320744419d5b0e6f8bd66568c55a6ebcd4d7bec04c70517052.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aeac060f9b65cc7a2236323d822c6a082a01e21afbb53e943f0251ca701d594c.jpeg",
    "https://cdn.faire.com/fastly/bf05eb5472aa54096a48309194192bb8b827358ac73ec029c79481a1f74956e8.jpeg",
    "https://cdn.faire.com/fastly/4b318ada17fc77f759455fdb5a56609c428d995e8293ed70fd17682e34ee4c8b.jpeg",
    "https://cdn.faire.com/fastly/5b256249b55e1e369acbdc6dd6801a87665356a2e92c2587cdbbeb35c9c94386.webp",
  ],
  priceDollars: 5.49,
  description:
    "Combining the finest black garlic with pure sea salt, this gourmet seasoning delivers rich, sweet notes similar to balsamic vinegar. Its deep umami flavor elevates dishes, making it an ideal choice for those seeking bold, refined taste.\n\nPerfect for enhancing salad dressings, deviled eggs, roasted vegetables, and steak, this versatile salt brings a high-end touch to every dish.\n\n*  Black Garlic & Mushroom Pasta recipe on back.\n\nOur USA made, farm to table products contain no MSG, no preservatives and are non-GMO, making them a great idea for host / hostess gifts or as a way to elevate special events such as game day, family gatherings and holidays.",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:09.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
